<template>
  <div>
    <div class="tile is-parent pl-1"
      v-if="$userInfo.isSystemAdministrator">
      <article class="tile is-child box">
        <div class="columns is-flex is-align-items-center">
          <div class="column">
            <p class="title">Default Administrator</p>
          </div>
        </div>
        <div class="field columns">
          <div class="column is-half">
            <label class="label">Email</label>
            <div class="control">
              <input class="input"
                type="text"
                v-model="user.email"
                @blur="handleBlur">
            </div>
          </div>
          <div class="column is-half">
            <label class="label">Username</label>
            <div class="control">
              <input class="input"
                type="text"
                v-model="user.username"
                @blur="handleBlur">
            </div>
          </div>
        </div>
        <div class="field columns">
          <div class="column is-half">
            <label class="label">Password</label>
            <div class="control">
              <input class="input"
                type="password"
                v-model="user.password"
                @blur="handleBlur">
            </div>
          </div>
        </div>
      </article>
    </div>
    <div v-else
      class="is-flex is-justify-content-center pt-5">
      <div class="notification is-danger is-flex is-justify-content-center is-size-4"
        style="width: 50%">
        You do not have permissions on this page
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyNewUserSetting',
  data() {
    return {
      user: {
        email: '',
        username: 'Administrator',
        password: ''
      }
    }
  },
  created() {
    const newCompany = this.$store.getters['companysetting/newCompany']
    if (newCompany && newCompany.user) {
      this.user = { ...newCompany.user }
      return
    } else {
      if (newCompany.companyDetails && newCompany.companyDetails.assetEmails) {
        var defaultEmail = newCompany.companyDetails.assetEmails.find((ae) => ae.isDefault)
        if (defaultEmail) {
          this.user.email = defaultEmail.address
        }
      }
    }
  },
  methods: {
    handleBlur() {
      this.$store.dispatch('companysetting/setStateProperty', { key: 'user', value: this.user })
    }
  },
  async beforeRouteLeave(to, from, next) {
    this.$store.dispatch('companysetting/setStateProperty', { key: 'user', value: this.user })
    next()
  }
}
</script>

